import {UsersListToolbar} from './UserListToolbar'
import {UsersListSearchComponent} from './UsersListSearchComponent'
interface Props {
  loading: boolean
}

const UsersListHeader = (props: Props) => {
  return (
    <div className='card-header border-0 pt-6'>
      <UsersListSearchComponent loading={props.loading} />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        <UsersListToolbar loading={props.loading} />
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {UsersListHeader}
